var _g, _g2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPlaceTicketGreen = function SvgPlaceTicketGreen(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "random_icon",
    "data-name": "random icon",
    width: 26.365,
    height: 22.817,
    viewBox: "0 0 26.365 22.817",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_939",
    "data-name": "Rectangle 939",
    transform: "matrix(0.999, -0.035, 0.035, 0.999, 7.097, 3.311)",
    fill: "none",
    stroke: "#03a688",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.63,
    height: 18.63,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17.63,
    height: 17.63,
    rx: 1.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_940",
    "data-name": "Rectangle 940",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 0, 4.822)",
    fill: "#fff",
    stroke: "#03a688",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.63,
    height: 18.63,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17.63,
    height: 17.63,
    rx: 1.5,
    fill: "none"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_162",
    "data-name": "Ellipse 162",
    cx: 1.774,
    cy: 1.774,
    r: 1.774,
    transform: "matrix(-0.259, -0.966, 0.966, -0.259, 8.731, 18.555)",
    fill: "#03a688"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_170",
    "data-name": "Ellipse 170",
    cx: 1.774,
    cy: 1.774,
    r: 1.774,
    transform: "matrix(-0.259, -0.966, 0.966, -0.259, 14.729, 16.948)",
    fill: "#03a688"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_163",
    "data-name": "Ellipse 163",
    cx: 1.774,
    cy: 1.774,
    r: 1.774,
    transform: "matrix(-0.259, -0.966, 0.966, -0.259, 7.583, 14.27)",
    fill: "#03a688"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_169",
    "data-name": "Ellipse 169",
    cx: 1.774,
    cy: 1.774,
    r: 1.774,
    transform: "matrix(-0.259, -0.966, 0.966, -0.259, 13.581, 12.663)",
    fill: "#03a688"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_164",
    "data-name": "Ellipse 164",
    cx: 1.774,
    cy: 1.774,
    r: 1.774,
    transform: "matrix(-0.259, -0.966, 0.966, -0.259, 6.435, 9.986)",
    fill: "#03a688"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_168",
    "data-name": "Ellipse 168",
    cx: 1.774,
    cy: 1.774,
    r: 1.774,
    transform: "matrix(-0.259, -0.966, 0.966, -0.259, 12.433, 8.378)",
    fill: "#03a688"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlaceTicketGreen, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };